import React, { useEffect, useCallback, useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router";

import { Dispatch, bindActionCreators } from "redux";

import { ConfirmDialog } from "@plex/react-components";

import { commonMessages } from "infrastructure/localization";
import { useLocalizedValues } from "ui/hooks";

import { IReleaseDetailsState } from "../ReleaseDetails.state";

import ReleaseTermsForm from "./ReleaseTermsForm";

interface IReleaseTermsProps {
  state: IReleaseDetailsState;
}

const ReleaseTerms: React.FC<IReleaseTermsProps> = ({ state }) => {
  const localizedTitles = useLocalizedValues(() => ({
    question: commonMessages.info("deleteRecordQuestion"),
    askTitle: commonMessages.title("confirmationDialog"),
    deleteButtonText: commonMessages.action("delete"),
    noButton: commonMessages.option("no"),
    yesButton: commonMessages.option("yes")
  }));

  const history = useHistory();
  const [isDialogOpened, setIsDialogOpened] = useState(false);

  useEffect(() => {
    if (state.shouldRedirect) {
      history.goBack();
    }
  }, [history, state.shouldRedirect]);

  const answers = [localizedTitles.yesButton, localizedTitles.noButton];
  const onDialogHide = useCallback(
    (answer: string) => {
      setIsDialogOpened(false);
      if (answer === localizedTitles.yesButton) {
      }
    },
    [localizedTitles]
  );

  return (
    <>
      <ReleaseTermsForm />
      <ConfirmDialog
        show={isDialogOpened}
        onHide={onDialogHide}
        question={localizedTitles.question}
        title={localizedTitles.askTitle}
        defaultAnswer={answers[1]}
        answers={answers}
      ></ConfirmDialog>
    </>
  );
};

export default connect(
  (state: { releaseDetails: IReleaseDetailsState }) => {
    return {
      state: state.releaseDetails
    };
  },
  (dispatch: Dispatch) => bindActionCreators({}, dispatch)
)(ReleaseTerms);
